<template>
  <div v-if="visible" class="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
    <div class="bg-white p-6 rounded-md w-full max-w-md">
      <h2 class="text-xl mb-4">{{ title }}</h2>
      <div class="mb-4">
        <p v-for="(message, index) in messages" :key="index">{{ message }}</p>
      </div>
      <div class="flex justify-end">
        <button type="button" @click="close" class="bg-blue-500 text-white px-4 py-2 rounded-md">{{ $t('ui.modal_message.close') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    messages: {
      type: Array,
      required: true
    }
  },
  emits: ['close'],
  methods: {
    close() {
      this.$emit('close');
    }
  }
};
</script>
